module.exports = __webpack_public_path__ + "img/artemisAds_logo@2x.6cbfd9ff.png";